import { connect } from 'react-redux'
import { actions } from 'appRedux/modules/SingleAiReport'
import { SourceModal as Source } from './SourceModal'


const mapStateToProps = (state, ownProps) => ({
	source_content: state.SingleAiReport.source,
	is_mobile: state.Layout.is_mobile,
});
const mapDispatchToProps = (dispatch, ownProps) => ({
	onSourceGetRequest: (data) => dispatch(actions.getSourceRequest(data)),
	onSourceReset: () => dispatch(actions.resetSource()),
	onSourceSet: (data) => dispatch(actions.setSource(data)),
})
const SourceModal = connect(mapStateToProps, mapDispatchToProps)(Source);


export { SourceModal }
